import script from "./GitPicker.vue?vue&type=script&lang=ts&setup=true"
export * from "./GitPicker.vue?vue&type=script&lang=ts&setup=true"

import "./GitPicker.vue?vue&type=style&index=0&id=5acebb90&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5acebb90"]])

export default __exports__